<template>
    <div class="footer">
        <section class="footer-content">
            <img v-if="footerInfo.web_bottom_logo" class="footer-logo" :src="footerInfo.web_bottom_logo" alt="" width="150" height="40">
            <div class="info logo">
                <div class="pre" >
                    <p class="img-discription">{{ footerInfo.web_company_name }}</p>
                </div>
                <span class="next">联系我们</span>
            </div>
            <div class="info">
                <span class="pre font-20">{{ footerInfo.web_text_sm }}</span>
                <span class="next font-20">{{ footerInfo.web_contact_number }}</span>
            </div>
            <div class="info font-14">
                <div class="pre">
                    <a :href="footerInfo.web_about_link_1" target="_blank">{{ footerInfo.web_about_text_1 }}</a>
                </div>
                <span class="next">地址：{{ footerInfo.web_address }}</span>
            </div>
            <div class="info font-14">
                <div class="pre" >
                    <a :href="footerInfo.web_about_link_2" target="_blank">{{ footerInfo.web_about_text_2 }}</a>
                </div>
                <span class="next">邮箱：{{ footerInfo.web_mail }}</span>
            </div>
            <div class="wechat-code" v-if="footerInfo.web_wx_account">
                <img :src="footerInfo.web_wx_account" width="110" height="110">
                <p class="font-12">扫一扫添加微信</p>
            </div>
        </section>
        <div class="end font-14">{{ footerInfo.web_record_number }}</div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                footerInfo: {},
                defaultTextInfo: {
                    web_company_name: '珊瑚课堂',
                    web_text_sm: '湖南腾慧科技有限公司',
                    web_contact_number: '+86 18679029388',
                    web_about_link_1: 'https://www.shanhuketang.com/index.html',
                    web_about_text_1: '商务合作',
                    web_address: '长沙市岳麓区芯城科技园2期16栋',
                    web_about_link_2: 'https://www.shanhuketang.com/fuwuyufaq.html',
                    web_about_text_2: '加入我们',
                    web_mail: 'wangkun@tengface.com',
                    web_record_number: '湘ICP备2021009742号',
                },
                defaultLogoInfo: {
                    web_wx_account: 'https://tengface-live-user-1308721187.cos.accelerate.myqcloud.com/uploads/2023/9/13/1491/1694599124136%E9%AD%94%E6%96%B9%E7%BD%91%E6%A0%A1-%E8%BD%AE%E6%92%AD%E5%9B%BE%E7%89%87%E8%A3%81%E5%89%AA',
                }
            }
        },
        computed: {
            ...mapGetters({
                webInfo: 'getWebInfo'
            }),
            showDefaultIcon() {
                return !this.webInfo.web_wx_account &&
                !this.webInfo.web_header_icon &&
                !this.webInfo.web_header_logo &&
                !this.webInfo.web_bottom_logo
            },
            showDefaultText() {
                return !this.webInfo.web_company_name &&
                !this.webInfo.web_address &&
                !this.webInfo.web_contact_number &&
                !this.webInfo.web_text_sm &&
                !this.webInfo.web_about_text_1 &&
                !this.webInfo.web_about_link_1 &&
                !this.webInfo.web_about_text_2 &&
                !this.webInfo.web_about_link_2 &&
                !this.webInfo.web_mail &&
                !this.webInfo.web_record_number
            }
        },
        created() {
            this.initFooter()
        },
        methods: {
            initFooter() {
                if(!this.showDefaultIcon && !this.showDefaultText) {
                    this.footerInfo = this.webInfo
                } else {
                    if(this.showDefaultIcon) {
                        this.footerInfo = { ...this.webInfo}
                    }
                    if(this.showDefaultText) {
                        this.footerInfo = { ...this.webInfo, ...this.footerInfo }
                    }
                }
            }
        }
    }
</script>

<style lang='scss' scoped>
.footer {
    background: #101115;
    color: #82858a;
    font-size: 16px;
    height: 258px;
    .footer-content {
        position: relative;
        width: 1260px;
        margin: auto;
        padding-top: 46px;
        .font-12 {
            font-size: 12px;
        }
        .font-14 {
            font-size: 14px;
        }
        .font-20 {
            font-size: 20px;
            color: #fff;
        }
        .info {
            display: flex;
            flex-wrap: wrap;
            margin-top: 20px;
            margin-left: 200px;
            &.logo {
                align-items: baseline;
                margin-top: 0;
            }
            a {
                color: #D0D3D9;
                text-decoration: none;
            }
            .pre {
                width: 56%;
                .img-discription {
                    margin: 0;
                    font-size: 20px;
                }
            }
            .next {
                width: 35%;
            }
        }
        .wechat-code {
            position: absolute;
            top: 50px;
            right: 0;
            text-align: center;
        }
        .footer-logo {
            position: absolute;
            top: 46px;
            left: 0;
        }
    }
}
.end {
    margin-top: 20px;
    width: 100%;
    height: 49px;
    background: #101115;
    text-align: center;
    line-height: 49px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: normal;
    color: #82858a;
}
</style>